<template>
  <div class="default-layout">
    <slot />
    <bottom-nav />
  </div>
</template>

<script>
import BottomNav from '@/components/BottomNav.vue'

export default {
  name: 'DefaultLayout',
  components: { BottomNav },
}
</script>

<style scoped>
.default-layout {
  padding-bottom: 60px;
}
</style>
